const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_RECEIPTS':
      return action.receipts;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/receipts.js